<template>
  <b-modal
    v-model="modalShow"
    @hidden="$emit('hidden')"
    size="md"
    centered
  >
    <template #modal-header="{ close }">
      <div class="d-flex align-items-center flex-fill">
        <h5 class="mb-0">{{ modalTitle }}</h5>

        <b-button class="ml-auto" size="sm" variant="link" @click="close()">
          <i class="fa fa-times" aria-hidden="true"></i>
        </b-button>
      </div>
    </template>

    <template #default>
      <div class="row">
        <div class="col-12">
          <div v-if="action === 'save'" class="alert alert-info">
            <i class="fa fa-info-circle mr-2"></i>
            Esta ação salvará os campos localmente e sobrescreverá o último salvamento (se houver).
          </div>
          
          <div v-else-if="action === 'load'" class="alert alert-warning">
            <i class="fa fa-exclamation-triangle mr-2"></i>
            Esta ação atualizará todos os campos do relatório com os dados salvos.
          </div>
          
          <div v-else-if="action === 'no-data'" class="alert alert-warning">
            <i class="fa fa-exclamation-triangle mr-2"></i>
            Não há dados salvos para carregar.
          </div>
        </div>
      </div>
    </template>

    <template #modal-footer="{ cancel }">
      <b-button
        v-if="action !== 'no-data'"
        variant="primary"
        @click="confirmAction"
        :disabled="isLoading"
      >
        <b-spinner small v-if="isLoading" class="mr-2"></b-spinner>
        {{ action === 'save' ? 'Salvar' : 'Carregar' }}
      </b-button>
      <b-button
        v-if="action == 'no-data'"
        variant="primary"
        @click="cancel"
        :disabled="isLoading"
      >
        <b-spinner small v-if="isLoading" class="mr-2"></b-spinner>
        Fechar
      </b-button>
    </template>
  </b-modal>
</template>

<script>
export default {
  name: 'SaveLoadFieldsModal',

  props: {
    action: {
      type: String,
      required: true,
      validator: value => ['save', 'load', 'no-data'].includes(value)
    }
  },

  data: () => ({
    modalShow: true,
    isLoading: false
  }),

  computed: {
    modalTitle() {
      switch (this.action) {
        case 'save':
          return 'Salvar Campos';
        case 'load':
          return 'Carregar Campos';
        case 'no-data':
          return 'Nenhum Dado Salvo';
        default:
          return 'Gerenciar Campos';
      }
    }
  },

  methods: {
    async confirmAction() {
      this.isLoading = true;
      
      try {
        if (this.action === 'save') {
          this.$emit('save');
        } else if (this.action === 'load') {
          this.$emit('load');
        }
        
        this.$emit('hidden');
      } catch (error) {
        console.error('Error in modal action:', error);
      } finally {
        this.isLoading = false;
      }
    }
  }
}
</script>

<style scoped>
.alert {
  margin-bottom: 0;
}
</style> 